// Global constants
export const ZOOM_IN = "tableView/ZOOM_IN";
export const ZOOM_OUT = "tableView/ZOOM_OUT";
export const RESET_ZOOM = "tableView/RESET_ZOOM";

// Local constants
export const ZOOM_IN_MUT = "ZOOM_IN_MUT";
export const ZOOM_OUT_MUT = "ZOOM_OUT_MUT";
export const RESET_ZOOM_MUT = "RESET_ZOOM_MUT";
